export const TableHelpers = {
    data() {
        return {
            tableColumns: [{
                title: this.$t('Expediente'),
                type: 'text',
                key: 'record',

            },
            {
                title: this.$t('Tipo Solicitud'),
                type: 'custom-html',
                key: 'accreditation_activity',
                modifier: (value) => {
                    return value.application_name;
                }
            },
            {
                title: this.$t('Tipo acreditación'),
                type: 'custom-html',
                key: 'accreditation_type',
                modifier: (value) => {
                    return value.name;
                }
            },
            {
                title: 'OEC',
                type: 'custom-html',
                key: 'organization',
                modifier: (value) => {
                    return value.business_name;
                }
            },

            {
                title: this.$t('Fecha creación'),
                type: 'custom-html',
                key: 'created_at',
                modifier: (value) => {
                    if (value) {
                        return moment(value).format("YYYY-MM-DD");
                    }
                }
            },
            {
                title: this.$t('Estado'),
                type: 'custom-html',
                key: 'status',
                modifier: (value) => {
                    return value.name;
                }
            }
            ],
            actionObj: {
                title: this.$t('Acciones'),
                type: 'action',

            }
        }
    },
}